import { useNavigate } from "react-router";
import { Button, DataGrid, Dialog, IGridColDef, IconButton, Stack } from "src/components"
import DialogActions from "src/components/DialogActions";
import DialogContent from "src/components/DialogContent";
import DialogTitle from "src/components/DialogTitle";
import BaseComponent from "src/core/base.component";
import { translate } from "src/i18n/tHelper";
import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import RecordInfo from "src/parts/Genel/record.info";
import { useAppDispatch, useAppSelector } from "src/store";
import KullaniciSlice from "src/store/Slices/Base/KullaniciSlice";
import KimlikSlice from "src/store/Slices/Genel/KimlikSlice";

interface KayitliKimliklerProps {
    closeEvent?: (e: number) => void
};

const translatePath = "pages|kimlik";
const KayitliKimlikler = (props: KayitliKimliklerProps): JSX.Element => {
    const state = useAppSelector(s => s.kimlik);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const rusca = (localStorage.getItem("lang") === "RU" || localStorage.getItem("lang") === "UZ");

    const checkHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKimlikDTO): void => {
        dispatch(KullaniciSlice.actions.setKimlikActiveRow(row));
        dispatch(KimlikSlice.actions.setState({
            ...state,
            activeRow: row,
            cancelPathName: "",
            kayitliKimliklerOpen: false,
            kayitliKimlikler: []
        }));
        if (state.cancelPathName !== "")
            navigate(state.cancelPathName);
    };
    const columns: IGridColDef<VwKimlikDTO>[] = [
        { field: rusca ? "soyadi" : "adi", width: 125, flex: 1, headerName: rusca ? translate(translatePath, "Soyadı") : translate(translatePath, "Adı") },
        { field: rusca ? "adi" : "soyadi", width: 125, headerName: rusca ? translate(translatePath, "Adı") : translate(translatePath, "Soyadı") },
        { field: "aileAdi", width: 125, headerName: translate(translatePath, "Aile Adı") },
        {
            field: "dogumTarihi", type: "date", width: 100, headerName: translate(translatePath, "Doğum Tarihi")
        },
        {
            field: "action",
            headerName: "",
            width: 80,
            renderCell: (params) => {
                return (
                    <Stack direction="row">
                        <IconButton customType="check" onClick={(e) => { checkHandler(e, params.row); }} />
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarihi}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                        />
                    </Stack>
                );
            },
        },
    ];
    const closeHandler = () => {
        dispatch(KimlikSlice.actions.setState({
            ...state,
            kayitliKimliklerOpen: false
        }));
    };

    return (
        <BaseComponent onCancelHandler={closeHandler}>
            <Dialog fullWidth open={state.kayitliKimliklerOpen} maxWidth="sm">
                <DialogTitle>{translate(translatePath, "İsim soyisime göre kayıtlı kimlikler")}</DialogTitle>
                <DialogContent>
                    <DataGrid
                        autoHeight
                        hiddenExport
                        hiddenFilters
                        enableQuickFilter
                        hiddenColumnsButton
                        pinnedColumns={{ right: ["action"] }}
                        columns={columns}
                        rows={state.kayitliKimlikler}
                    />
                </DialogContent>
                <DialogActions>
                    <Button customType="close" onClick={closeHandler} />
                </DialogActions>
            </Dialog>
        </BaseComponent>
    );
};
export default KayitliKimlikler;